import { getStatusAdsCampaign } from "../../../services/adsCampaigns";
import {
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
} from "../../../utils/constants";

export const getGlobalReportCampaignCounts = (campaigns = {}) => {
  const values = Object.values(campaigns);
  let active = 0;
  let paused = 0;

  values.forEach((campaign) => {
    const status = getStatusAdsCampaign({
      states: campaign?.states,
      target: "general",
    });

    if (status === ADS_CAMPAIGN_STATUS_ACTIVE) {
      active += 1;
    } else if (status === ADS_CAMPAIGN_STATUS_DEACTIVATED) {
      paused += 1;
    }
  });

  return {
    active,
    total: values.length,
    paused,
  };
};
